/**
 * Check whether a field value is a server-masked placeholder (e.g. "********").
 */
export const isMaskedValue = (value?: string) => {
  const normalized = value?.trim()
  return !!normalized && /^\*{4,}$/.test(normalized)
}
